/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as OperatorLoginRouteImport } from './routes/operator.login'
import { Route as AppWygladRouteImport } from './routes/_app.wyglad'
import { Route as AppTresciRouteImport } from './routes/_app.tresci'
import { Route as AppTeamRouteImport } from './routes/_app.team'
import { Route as AppSmsRouteImport } from './routes/_app.sms'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppPublishRouteImport } from './routes/_app.publish'
import { Route as AppOperatorRouteImport } from './routes/_app.operator'
import { Route as AppMessagesRouteImport } from './routes/_app.messages'
import { Route as AppMediaRouteImport } from './routes/_app.media'
import { Route as AppInboxRouteImport } from './routes/_app.inbox'
import { Route as AppHelpRouteImport } from './routes/_app.help'
import { Route as AppGrowthRouteImport } from './routes/_app.growth'
import { Route as AppCoordinateRouteImport } from './routes/_app.coordinate'
import { Route as AppCalendarRouteImport } from './routes/_app.calendar'
import { Route as AppBriefRouteImport } from './routes/_app.brief'
import { Route as AppBillingRouteImport } from './routes/_app.billing'
import { Route as AppStronyIndexRouteImport } from './routes/_app.strony.index'
import { Route as AppOperatorIndexRouteImport } from './routes/_app.operator.index'
import { Route as AppBriefIndexRouteImport } from './routes/_app.brief.index'
import { Route as TeamAcceptTokenRouteImport } from './routes/team.accept.$token'
import { Route as AuthSetPasswordTokenRouteImport } from './routes/auth.set-password.$token'
import { Route as AppTresciRealizacjeRouteImport } from './routes/_app.tresci.realizacje'
import { Route as AppTresciAktualnosciRouteImport } from './routes/_app.tresci.aktualnosci'
import { Route as AppStronyPageIdRouteImport } from './routes/_app.strony.$pageId'
import { Route as AppSmsCampaignsRouteImport } from './routes/_app.sms.campaigns'
import { Route as AppOperatorUsersRouteImport } from './routes/_app.operator.users'
import { Route as AppOperatorTenantsRouteImport } from './routes/_app.operator.tenants'
import { Route as AppOperatorServicesRouteImport } from './routes/_app.operator.services'
import { Route as AppOperatorSalesRouteImport } from './routes/_app.operator.sales'
import { Route as AppOperatorFunnelRouteImport } from './routes/_app.operator.funnel'
import { Route as AppOperatorForbiddenRouteImport } from './routes/_app.operator.forbidden'
import { Route as AppOperatorConversationsRouteImport } from './routes/_app.operator.conversations'
import { Route as AppOperatorContentOrdersRouteImport } from './routes/_app.operator.content-orders'
import { Route as AppOperatorAuditRouteImport } from './routes/_app.operator.audit'
import { Route as AppBriefTestimonialsRouteImport } from './routes/_app.brief.testimonials'
import { Route as AppBriefTeamRouteImport } from './routes/_app.brief.team'
import { Route as AppBriefServicesRouteImport } from './routes/_app.brief.services'
import { Route as AppBriefMenuRouteImport } from './routes/_app.brief.menu'
import { Route as AppBriefIdentityRouteImport } from './routes/_app.brief.identity'
import { Route as AppBriefFaqRouteImport } from './routes/_app.brief.faq'
import { Route as AppBriefEquipmentRouteImport } from './routes/_app.brief.equipment'
import { Route as AppBriefBookingRouteImport } from './routes/_app.brief.booking'
import { Route as AppBriefAccreditationsRouteImport } from './routes/_app.brief.accreditations'
import { Route as AppSmsCampaignsIdRouteImport } from './routes/_app.sms.campaigns.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const OperatorLoginRoute = OperatorLoginRouteImport.update({
  id: '/operator/login',
  path: '/operator/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWygladRoute = AppWygladRouteImport.update({
  id: '/wyglad',
  path: '/wyglad',
  getParentRoute: () => AppRoute,
} as any)
const AppTresciRoute = AppTresciRouteImport.update({
  id: '/tresci',
  path: '/tresci',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AppSmsRoute = AppSmsRouteImport.update({
  id: '/sms',
  path: '/sms',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppPublishRoute = AppPublishRouteImport.update({
  id: '/publish',
  path: '/publish',
  getParentRoute: () => AppRoute,
} as any)
const AppOperatorRoute = AppOperatorRouteImport.update({
  id: '/operator',
  path: '/operator',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppMediaRoute = AppMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AppGrowthRoute = AppGrowthRouteImport.update({
  id: '/growth',
  path: '/growth',
  getParentRoute: () => AppRoute,
} as any)
const AppCoordinateRoute = AppCoordinateRouteImport.update({
  id: '/coordinate',
  path: '/coordinate',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppBriefRoute = AppBriefRouteImport.update({
  id: '/brief',
  path: '/brief',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppStronyIndexRoute = AppStronyIndexRouteImport.update({
  id: '/strony/',
  path: '/strony/',
  getParentRoute: () => AppRoute,
} as any)
const AppOperatorIndexRoute = AppOperatorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOperatorRoute,
} as any)
const AppBriefIndexRoute = AppBriefIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBriefRoute,
} as any)
const TeamAcceptTokenRoute = TeamAcceptTokenRouteImport.update({
  id: '/team/accept/$token',
  path: '/team/accept/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSetPasswordTokenRoute = AuthSetPasswordTokenRouteImport.update({
  id: '/auth/set-password/$token',
  path: '/auth/set-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTresciRealizacjeRoute = AppTresciRealizacjeRouteImport.update({
  id: '/realizacje',
  path: '/realizacje',
  getParentRoute: () => AppTresciRoute,
} as any)
const AppTresciAktualnosciRoute = AppTresciAktualnosciRouteImport.update({
  id: '/aktualnosci',
  path: '/aktualnosci',
  getParentRoute: () => AppTresciRoute,
} as any)
const AppStronyPageIdRoute = AppStronyPageIdRouteImport.update({
  id: '/strony/$pageId',
  path: '/strony/$pageId',
  getParentRoute: () => AppRoute,
} as any)
const AppSmsCampaignsRoute = AppSmsCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AppSmsRoute,
} as any)
const AppOperatorUsersRoute = AppOperatorUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppOperatorRoute,
} as any)
const AppOperatorTenantsRoute = AppOperatorTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AppOperatorRoute,
} as any)
const AppOperatorServicesRoute = AppOperatorServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AppOperatorRoute,
} as any)
const AppOperatorSalesRoute = AppOperatorSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppOperatorRoute,
} as any)
const AppOperatorFunnelRoute = AppOperatorFunnelRouteImport.update({
  id: '/funnel',
  path: '/funnel',
  getParentRoute: () => AppOperatorRoute,
} as any)
const AppOperatorForbiddenRoute = AppOperatorForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => AppOperatorRoute,
} as any)
const AppOperatorConversationsRoute =
  AppOperatorConversationsRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => AppOperatorRoute,
  } as any)
const AppOperatorContentOrdersRoute =
  AppOperatorContentOrdersRouteImport.update({
    id: '/content-orders',
    path: '/content-orders',
    getParentRoute: () => AppOperatorRoute,
  } as any)
const AppOperatorAuditRoute = AppOperatorAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppOperatorRoute,
} as any)
const AppBriefTestimonialsRoute = AppBriefTestimonialsRouteImport.update({
  id: '/testimonials',
  path: '/testimonials',
  getParentRoute: () => AppBriefRoute,
} as any)
const AppBriefTeamRoute = AppBriefTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppBriefRoute,
} as any)
const AppBriefServicesRoute = AppBriefServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AppBriefRoute,
} as any)
const AppBriefMenuRoute = AppBriefMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => AppBriefRoute,
} as any)
const AppBriefIdentityRoute = AppBriefIdentityRouteImport.update({
  id: '/identity',
  path: '/identity',
  getParentRoute: () => AppBriefRoute,
} as any)
const AppBriefFaqRoute = AppBriefFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => AppBriefRoute,
} as any)
const AppBriefEquipmentRoute = AppBriefEquipmentRouteImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => AppBriefRoute,
} as any)
const AppBriefBookingRoute = AppBriefBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => AppBriefRoute,
} as any)
const AppBriefAccreditationsRoute = AppBriefAccreditationsRouteImport.update({
  id: '/accreditations',
  path: '/accreditations',
  getParentRoute: () => AppBriefRoute,
} as any)
const AppSmsCampaignsIdRoute = AppSmsCampaignsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppSmsCampaignsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/billing': typeof AppBillingRoute
  '/brief': typeof AppBriefRouteWithChildren
  '/calendar': typeof AppCalendarRoute
  '/coordinate': typeof AppCoordinateRoute
  '/growth': typeof AppGrowthRoute
  '/help': typeof AppHelpRoute
  '/inbox': typeof AppInboxRoute
  '/media': typeof AppMediaRoute
  '/messages': typeof AppMessagesRoute
  '/operator': typeof AppOperatorRouteWithChildren
  '/publish': typeof AppPublishRoute
  '/settings': typeof AppSettingsRoute
  '/sms': typeof AppSmsRouteWithChildren
  '/team': typeof AppTeamRoute
  '/tresci': typeof AppTresciRouteWithChildren
  '/wyglad': typeof AppWygladRoute
  '/operator/login': typeof OperatorLoginRoute
  '/brief/accreditations': typeof AppBriefAccreditationsRoute
  '/brief/booking': typeof AppBriefBookingRoute
  '/brief/equipment': typeof AppBriefEquipmentRoute
  '/brief/faq': typeof AppBriefFaqRoute
  '/brief/identity': typeof AppBriefIdentityRoute
  '/brief/menu': typeof AppBriefMenuRoute
  '/brief/services': typeof AppBriefServicesRoute
  '/brief/team': typeof AppBriefTeamRoute
  '/brief/testimonials': typeof AppBriefTestimonialsRoute
  '/operator/audit': typeof AppOperatorAuditRoute
  '/operator/content-orders': typeof AppOperatorContentOrdersRoute
  '/operator/conversations': typeof AppOperatorConversationsRoute
  '/operator/forbidden': typeof AppOperatorForbiddenRoute
  '/operator/funnel': typeof AppOperatorFunnelRoute
  '/operator/sales': typeof AppOperatorSalesRoute
  '/operator/services': typeof AppOperatorServicesRoute
  '/operator/tenants': typeof AppOperatorTenantsRoute
  '/operator/users': typeof AppOperatorUsersRoute
  '/sms/campaigns': typeof AppSmsCampaignsRouteWithChildren
  '/strony/$pageId': typeof AppStronyPageIdRoute
  '/tresci/aktualnosci': typeof AppTresciAktualnosciRoute
  '/tresci/realizacje': typeof AppTresciRealizacjeRoute
  '/auth/set-password/$token': typeof AuthSetPasswordTokenRoute
  '/team/accept/$token': typeof TeamAcceptTokenRoute
  '/brief/': typeof AppBriefIndexRoute
  '/operator/': typeof AppOperatorIndexRoute
  '/strony/': typeof AppStronyIndexRoute
  '/sms/campaigns/$id': typeof AppSmsCampaignsIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/billing': typeof AppBillingRoute
  '/calendar': typeof AppCalendarRoute
  '/coordinate': typeof AppCoordinateRoute
  '/growth': typeof AppGrowthRoute
  '/help': typeof AppHelpRoute
  '/inbox': typeof AppInboxRoute
  '/media': typeof AppMediaRoute
  '/messages': typeof AppMessagesRoute
  '/publish': typeof AppPublishRoute
  '/settings': typeof AppSettingsRoute
  '/sms': typeof AppSmsRouteWithChildren
  '/team': typeof AppTeamRoute
  '/tresci': typeof AppTresciRouteWithChildren
  '/wyglad': typeof AppWygladRoute
  '/operator/login': typeof OperatorLoginRoute
  '/': typeof AppIndexRoute
  '/brief/accreditations': typeof AppBriefAccreditationsRoute
  '/brief/booking': typeof AppBriefBookingRoute
  '/brief/equipment': typeof AppBriefEquipmentRoute
  '/brief/faq': typeof AppBriefFaqRoute
  '/brief/identity': typeof AppBriefIdentityRoute
  '/brief/menu': typeof AppBriefMenuRoute
  '/brief/services': typeof AppBriefServicesRoute
  '/brief/team': typeof AppBriefTeamRoute
  '/brief/testimonials': typeof AppBriefTestimonialsRoute
  '/operator/audit': typeof AppOperatorAuditRoute
  '/operator/content-orders': typeof AppOperatorContentOrdersRoute
  '/operator/conversations': typeof AppOperatorConversationsRoute
  '/operator/forbidden': typeof AppOperatorForbiddenRoute
  '/operator/funnel': typeof AppOperatorFunnelRoute
  '/operator/sales': typeof AppOperatorSalesRoute
  '/operator/services': typeof AppOperatorServicesRoute
  '/operator/tenants': typeof AppOperatorTenantsRoute
  '/operator/users': typeof AppOperatorUsersRoute
  '/sms/campaigns': typeof AppSmsCampaignsRouteWithChildren
  '/strony/$pageId': typeof AppStronyPageIdRoute
  '/tresci/aktualnosci': typeof AppTresciAktualnosciRoute
  '/tresci/realizacje': typeof AppTresciRealizacjeRoute
  '/auth/set-password/$token': typeof AuthSetPasswordTokenRoute
  '/team/accept/$token': typeof TeamAcceptTokenRoute
  '/brief': typeof AppBriefIndexRoute
  '/operator': typeof AppOperatorIndexRoute
  '/strony': typeof AppStronyIndexRoute
  '/sms/campaigns/$id': typeof AppSmsCampaignsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/brief': typeof AppBriefRouteWithChildren
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/coordinate': typeof AppCoordinateRoute
  '/_app/growth': typeof AppGrowthRoute
  '/_app/help': typeof AppHelpRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/media': typeof AppMediaRoute
  '/_app/messages': typeof AppMessagesRoute
  '/_app/operator': typeof AppOperatorRouteWithChildren
  '/_app/publish': typeof AppPublishRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/sms': typeof AppSmsRouteWithChildren
  '/_app/team': typeof AppTeamRoute
  '/_app/tresci': typeof AppTresciRouteWithChildren
  '/_app/wyglad': typeof AppWygladRoute
  '/operator/login': typeof OperatorLoginRoute
  '/_app/': typeof AppIndexRoute
  '/_app/brief/accreditations': typeof AppBriefAccreditationsRoute
  '/_app/brief/booking': typeof AppBriefBookingRoute
  '/_app/brief/equipment': typeof AppBriefEquipmentRoute
  '/_app/brief/faq': typeof AppBriefFaqRoute
  '/_app/brief/identity': typeof AppBriefIdentityRoute
  '/_app/brief/menu': typeof AppBriefMenuRoute
  '/_app/brief/services': typeof AppBriefServicesRoute
  '/_app/brief/team': typeof AppBriefTeamRoute
  '/_app/brief/testimonials': typeof AppBriefTestimonialsRoute
  '/_app/operator/audit': typeof AppOperatorAuditRoute
  '/_app/operator/content-orders': typeof AppOperatorContentOrdersRoute
  '/_app/operator/conversations': typeof AppOperatorConversationsRoute
  '/_app/operator/forbidden': typeof AppOperatorForbiddenRoute
  '/_app/operator/funnel': typeof AppOperatorFunnelRoute
  '/_app/operator/sales': typeof AppOperatorSalesRoute
  '/_app/operator/services': typeof AppOperatorServicesRoute
  '/_app/operator/tenants': typeof AppOperatorTenantsRoute
  '/_app/operator/users': typeof AppOperatorUsersRoute
  '/_app/sms/campaigns': typeof AppSmsCampaignsRouteWithChildren
  '/_app/strony/$pageId': typeof AppStronyPageIdRoute
  '/_app/tresci/aktualnosci': typeof AppTresciAktualnosciRoute
  '/_app/tresci/realizacje': typeof AppTresciRealizacjeRoute
  '/auth/set-password/$token': typeof AuthSetPasswordTokenRoute
  '/team/accept/$token': typeof TeamAcceptTokenRoute
  '/_app/brief/': typeof AppBriefIndexRoute
  '/_app/operator/': typeof AppOperatorIndexRoute
  '/_app/strony/': typeof AppStronyIndexRoute
  '/_app/sms/campaigns/$id': typeof AppSmsCampaignsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/billing'
    | '/brief'
    | '/calendar'
    | '/coordinate'
    | '/growth'
    | '/help'
    | '/inbox'
    | '/media'
    | '/messages'
    | '/operator'
    | '/publish'
    | '/settings'
    | '/sms'
    | '/team'
    | '/tresci'
    | '/wyglad'
    | '/operator/login'
    | '/brief/accreditations'
    | '/brief/booking'
    | '/brief/equipment'
    | '/brief/faq'
    | '/brief/identity'
    | '/brief/menu'
    | '/brief/services'
    | '/brief/team'
    | '/brief/testimonials'
    | '/operator/audit'
    | '/operator/content-orders'
    | '/operator/conversations'
    | '/operator/forbidden'
    | '/operator/funnel'
    | '/operator/sales'
    | '/operator/services'
    | '/operator/tenants'
    | '/operator/users'
    | '/sms/campaigns'
    | '/strony/$pageId'
    | '/tresci/aktualnosci'
    | '/tresci/realizacje'
    | '/auth/set-password/$token'
    | '/team/accept/$token'
    | '/brief/'
    | '/operator/'
    | '/strony/'
    | '/sms/campaigns/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/billing'
    | '/calendar'
    | '/coordinate'
    | '/growth'
    | '/help'
    | '/inbox'
    | '/media'
    | '/messages'
    | '/publish'
    | '/settings'
    | '/sms'
    | '/team'
    | '/tresci'
    | '/wyglad'
    | '/operator/login'
    | '/'
    | '/brief/accreditations'
    | '/brief/booking'
    | '/brief/equipment'
    | '/brief/faq'
    | '/brief/identity'
    | '/brief/menu'
    | '/brief/services'
    | '/brief/team'
    | '/brief/testimonials'
    | '/operator/audit'
    | '/operator/content-orders'
    | '/operator/conversations'
    | '/operator/forbidden'
    | '/operator/funnel'
    | '/operator/sales'
    | '/operator/services'
    | '/operator/tenants'
    | '/operator/users'
    | '/sms/campaigns'
    | '/strony/$pageId'
    | '/tresci/aktualnosci'
    | '/tresci/realizacje'
    | '/auth/set-password/$token'
    | '/team/accept/$token'
    | '/brief'
    | '/operator'
    | '/strony'
    | '/sms/campaigns/$id'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/billing'
    | '/_app/brief'
    | '/_app/calendar'
    | '/_app/coordinate'
    | '/_app/growth'
    | '/_app/help'
    | '/_app/inbox'
    | '/_app/media'
    | '/_app/messages'
    | '/_app/operator'
    | '/_app/publish'
    | '/_app/settings'
    | '/_app/sms'
    | '/_app/team'
    | '/_app/tresci'
    | '/_app/wyglad'
    | '/operator/login'
    | '/_app/'
    | '/_app/brief/accreditations'
    | '/_app/brief/booking'
    | '/_app/brief/equipment'
    | '/_app/brief/faq'
    | '/_app/brief/identity'
    | '/_app/brief/menu'
    | '/_app/brief/services'
    | '/_app/brief/team'
    | '/_app/brief/testimonials'
    | '/_app/operator/audit'
    | '/_app/operator/content-orders'
    | '/_app/operator/conversations'
    | '/_app/operator/forbidden'
    | '/_app/operator/funnel'
    | '/_app/operator/sales'
    | '/_app/operator/services'
    | '/_app/operator/tenants'
    | '/_app/operator/users'
    | '/_app/sms/campaigns'
    | '/_app/strony/$pageId'
    | '/_app/tresci/aktualnosci'
    | '/_app/tresci/realizacje'
    | '/auth/set-password/$token'
    | '/team/accept/$token'
    | '/_app/brief/'
    | '/_app/operator/'
    | '/_app/strony/'
    | '/_app/sms/campaigns/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  OperatorLoginRoute: typeof OperatorLoginRoute
  AuthSetPasswordTokenRoute: typeof AuthSetPasswordTokenRoute
  TeamAcceptTokenRoute: typeof TeamAcceptTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/operator/login': {
      id: '/operator/login'
      path: '/operator/login'
      fullPath: '/operator/login'
      preLoaderRoute: typeof OperatorLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/wyglad': {
      id: '/_app/wyglad'
      path: '/wyglad'
      fullPath: '/wyglad'
      preLoaderRoute: typeof AppWygladRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tresci': {
      id: '/_app/tresci'
      path: '/tresci'
      fullPath: '/tresci'
      preLoaderRoute: typeof AppTresciRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sms': {
      id: '/_app/sms'
      path: '/sms'
      fullPath: '/sms'
      preLoaderRoute: typeof AppSmsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/publish': {
      id: '/_app/publish'
      path: '/publish'
      fullPath: '/publish'
      preLoaderRoute: typeof AppPublishRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operator': {
      id: '/_app/operator'
      path: '/operator'
      fullPath: '/operator'
      preLoaderRoute: typeof AppOperatorRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/media': {
      id: '/_app/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof AppMediaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/growth': {
      id: '/_app/growth'
      path: '/growth'
      fullPath: '/growth'
      preLoaderRoute: typeof AppGrowthRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coordinate': {
      id: '/_app/coordinate'
      path: '/coordinate'
      fullPath: '/coordinate'
      preLoaderRoute: typeof AppCoordinateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brief': {
      id: '/_app/brief'
      path: '/brief'
      fullPath: '/brief'
      preLoaderRoute: typeof AppBriefRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/strony/': {
      id: '/_app/strony/'
      path: '/strony'
      fullPath: '/strony/'
      preLoaderRoute: typeof AppStronyIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operator/': {
      id: '/_app/operator/'
      path: '/'
      fullPath: '/operator/'
      preLoaderRoute: typeof AppOperatorIndexRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/brief/': {
      id: '/_app/brief/'
      path: '/'
      fullPath: '/brief/'
      preLoaderRoute: typeof AppBriefIndexRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/team/accept/$token': {
      id: '/team/accept/$token'
      path: '/team/accept/$token'
      fullPath: '/team/accept/$token'
      preLoaderRoute: typeof TeamAcceptTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/set-password/$token': {
      id: '/auth/set-password/$token'
      path: '/auth/set-password/$token'
      fullPath: '/auth/set-password/$token'
      preLoaderRoute: typeof AuthSetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/tresci/realizacje': {
      id: '/_app/tresci/realizacje'
      path: '/realizacje'
      fullPath: '/tresci/realizacje'
      preLoaderRoute: typeof AppTresciRealizacjeRouteImport
      parentRoute: typeof AppTresciRoute
    }
    '/_app/tresci/aktualnosci': {
      id: '/_app/tresci/aktualnosci'
      path: '/aktualnosci'
      fullPath: '/tresci/aktualnosci'
      preLoaderRoute: typeof AppTresciAktualnosciRouteImport
      parentRoute: typeof AppTresciRoute
    }
    '/_app/strony/$pageId': {
      id: '/_app/strony/$pageId'
      path: '/strony/$pageId'
      fullPath: '/strony/$pageId'
      preLoaderRoute: typeof AppStronyPageIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sms/campaigns': {
      id: '/_app/sms/campaigns'
      path: '/campaigns'
      fullPath: '/sms/campaigns'
      preLoaderRoute: typeof AppSmsCampaignsRouteImport
      parentRoute: typeof AppSmsRoute
    }
    '/_app/operator/users': {
      id: '/_app/operator/users'
      path: '/users'
      fullPath: '/operator/users'
      preLoaderRoute: typeof AppOperatorUsersRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/operator/tenants': {
      id: '/_app/operator/tenants'
      path: '/tenants'
      fullPath: '/operator/tenants'
      preLoaderRoute: typeof AppOperatorTenantsRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/operator/services': {
      id: '/_app/operator/services'
      path: '/services'
      fullPath: '/operator/services'
      preLoaderRoute: typeof AppOperatorServicesRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/operator/sales': {
      id: '/_app/operator/sales'
      path: '/sales'
      fullPath: '/operator/sales'
      preLoaderRoute: typeof AppOperatorSalesRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/operator/funnel': {
      id: '/_app/operator/funnel'
      path: '/funnel'
      fullPath: '/operator/funnel'
      preLoaderRoute: typeof AppOperatorFunnelRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/operator/forbidden': {
      id: '/_app/operator/forbidden'
      path: '/forbidden'
      fullPath: '/operator/forbidden'
      preLoaderRoute: typeof AppOperatorForbiddenRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/operator/conversations': {
      id: '/_app/operator/conversations'
      path: '/conversations'
      fullPath: '/operator/conversations'
      preLoaderRoute: typeof AppOperatorConversationsRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/operator/content-orders': {
      id: '/_app/operator/content-orders'
      path: '/content-orders'
      fullPath: '/operator/content-orders'
      preLoaderRoute: typeof AppOperatorContentOrdersRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/operator/audit': {
      id: '/_app/operator/audit'
      path: '/audit'
      fullPath: '/operator/audit'
      preLoaderRoute: typeof AppOperatorAuditRouteImport
      parentRoute: typeof AppOperatorRoute
    }
    '/_app/brief/testimonials': {
      id: '/_app/brief/testimonials'
      path: '/testimonials'
      fullPath: '/brief/testimonials'
      preLoaderRoute: typeof AppBriefTestimonialsRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/_app/brief/team': {
      id: '/_app/brief/team'
      path: '/team'
      fullPath: '/brief/team'
      preLoaderRoute: typeof AppBriefTeamRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/_app/brief/services': {
      id: '/_app/brief/services'
      path: '/services'
      fullPath: '/brief/services'
      preLoaderRoute: typeof AppBriefServicesRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/_app/brief/menu': {
      id: '/_app/brief/menu'
      path: '/menu'
      fullPath: '/brief/menu'
      preLoaderRoute: typeof AppBriefMenuRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/_app/brief/identity': {
      id: '/_app/brief/identity'
      path: '/identity'
      fullPath: '/brief/identity'
      preLoaderRoute: typeof AppBriefIdentityRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/_app/brief/faq': {
      id: '/_app/brief/faq'
      path: '/faq'
      fullPath: '/brief/faq'
      preLoaderRoute: typeof AppBriefFaqRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/_app/brief/equipment': {
      id: '/_app/brief/equipment'
      path: '/equipment'
      fullPath: '/brief/equipment'
      preLoaderRoute: typeof AppBriefEquipmentRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/_app/brief/booking': {
      id: '/_app/brief/booking'
      path: '/booking'
      fullPath: '/brief/booking'
      preLoaderRoute: typeof AppBriefBookingRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/_app/brief/accreditations': {
      id: '/_app/brief/accreditations'
      path: '/accreditations'
      fullPath: '/brief/accreditations'
      preLoaderRoute: typeof AppBriefAccreditationsRouteImport
      parentRoute: typeof AppBriefRoute
    }
    '/_app/sms/campaigns/$id': {
      id: '/_app/sms/campaigns/$id'
      path: '/$id'
      fullPath: '/sms/campaigns/$id'
      preLoaderRoute: typeof AppSmsCampaignsIdRouteImport
      parentRoute: typeof AppSmsCampaignsRoute
    }
  }
}

interface AppBriefRouteChildren {
  AppBriefAccreditationsRoute: typeof AppBriefAccreditationsRoute
  AppBriefBookingRoute: typeof AppBriefBookingRoute
  AppBriefEquipmentRoute: typeof AppBriefEquipmentRoute
  AppBriefFaqRoute: typeof AppBriefFaqRoute
  AppBriefIdentityRoute: typeof AppBriefIdentityRoute
  AppBriefMenuRoute: typeof AppBriefMenuRoute
  AppBriefServicesRoute: typeof AppBriefServicesRoute
  AppBriefTeamRoute: typeof AppBriefTeamRoute
  AppBriefTestimonialsRoute: typeof AppBriefTestimonialsRoute
  AppBriefIndexRoute: typeof AppBriefIndexRoute
}

const AppBriefRouteChildren: AppBriefRouteChildren = {
  AppBriefAccreditationsRoute: AppBriefAccreditationsRoute,
  AppBriefBookingRoute: AppBriefBookingRoute,
  AppBriefEquipmentRoute: AppBriefEquipmentRoute,
  AppBriefFaqRoute: AppBriefFaqRoute,
  AppBriefIdentityRoute: AppBriefIdentityRoute,
  AppBriefMenuRoute: AppBriefMenuRoute,
  AppBriefServicesRoute: AppBriefServicesRoute,
  AppBriefTeamRoute: AppBriefTeamRoute,
  AppBriefTestimonialsRoute: AppBriefTestimonialsRoute,
  AppBriefIndexRoute: AppBriefIndexRoute,
}

const AppBriefRouteWithChildren = AppBriefRoute._addFileChildren(
  AppBriefRouteChildren,
)

interface AppOperatorRouteChildren {
  AppOperatorAuditRoute: typeof AppOperatorAuditRoute
  AppOperatorContentOrdersRoute: typeof AppOperatorContentOrdersRoute
  AppOperatorConversationsRoute: typeof AppOperatorConversationsRoute
  AppOperatorForbiddenRoute: typeof AppOperatorForbiddenRoute
  AppOperatorFunnelRoute: typeof AppOperatorFunnelRoute
  AppOperatorSalesRoute: typeof AppOperatorSalesRoute
  AppOperatorServicesRoute: typeof AppOperatorServicesRoute
  AppOperatorTenantsRoute: typeof AppOperatorTenantsRoute
  AppOperatorUsersRoute: typeof AppOperatorUsersRoute
  AppOperatorIndexRoute: typeof AppOperatorIndexRoute
}

const AppOperatorRouteChildren: AppOperatorRouteChildren = {
  AppOperatorAuditRoute: AppOperatorAuditRoute,
  AppOperatorContentOrdersRoute: AppOperatorContentOrdersRoute,
  AppOperatorConversationsRoute: AppOperatorConversationsRoute,
  AppOperatorForbiddenRoute: AppOperatorForbiddenRoute,
  AppOperatorFunnelRoute: AppOperatorFunnelRoute,
  AppOperatorSalesRoute: AppOperatorSalesRoute,
  AppOperatorServicesRoute: AppOperatorServicesRoute,
  AppOperatorTenantsRoute: AppOperatorTenantsRoute,
  AppOperatorUsersRoute: AppOperatorUsersRoute,
  AppOperatorIndexRoute: AppOperatorIndexRoute,
}

const AppOperatorRouteWithChildren = AppOperatorRoute._addFileChildren(
  AppOperatorRouteChildren,
)

interface AppSmsCampaignsRouteChildren {
  AppSmsCampaignsIdRoute: typeof AppSmsCampaignsIdRoute
}

const AppSmsCampaignsRouteChildren: AppSmsCampaignsRouteChildren = {
  AppSmsCampaignsIdRoute: AppSmsCampaignsIdRoute,
}

const AppSmsCampaignsRouteWithChildren = AppSmsCampaignsRoute._addFileChildren(
  AppSmsCampaignsRouteChildren,
)

interface AppSmsRouteChildren {
  AppSmsCampaignsRoute: typeof AppSmsCampaignsRouteWithChildren
}

const AppSmsRouteChildren: AppSmsRouteChildren = {
  AppSmsCampaignsRoute: AppSmsCampaignsRouteWithChildren,
}

const AppSmsRouteWithChildren =
  AppSmsRoute._addFileChildren(AppSmsRouteChildren)

interface AppTresciRouteChildren {
  AppTresciAktualnosciRoute: typeof AppTresciAktualnosciRoute
  AppTresciRealizacjeRoute: typeof AppTresciRealizacjeRoute
}

const AppTresciRouteChildren: AppTresciRouteChildren = {
  AppTresciAktualnosciRoute: AppTresciAktualnosciRoute,
  AppTresciRealizacjeRoute: AppTresciRealizacjeRoute,
}

const AppTresciRouteWithChildren = AppTresciRoute._addFileChildren(
  AppTresciRouteChildren,
)

interface AppRouteChildren {
  AppBillingRoute: typeof AppBillingRoute
  AppBriefRoute: typeof AppBriefRouteWithChildren
  AppCalendarRoute: typeof AppCalendarRoute
  AppCoordinateRoute: typeof AppCoordinateRoute
  AppGrowthRoute: typeof AppGrowthRoute
  AppHelpRoute: typeof AppHelpRoute
  AppInboxRoute: typeof AppInboxRoute
  AppMediaRoute: typeof AppMediaRoute
  AppMessagesRoute: typeof AppMessagesRoute
  AppOperatorRoute: typeof AppOperatorRouteWithChildren
  AppPublishRoute: typeof AppPublishRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSmsRoute: typeof AppSmsRouteWithChildren
  AppTeamRoute: typeof AppTeamRoute
  AppTresciRoute: typeof AppTresciRouteWithChildren
  AppWygladRoute: typeof AppWygladRoute
  AppIndexRoute: typeof AppIndexRoute
  AppStronyPageIdRoute: typeof AppStronyPageIdRoute
  AppStronyIndexRoute: typeof AppStronyIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBillingRoute: AppBillingRoute,
  AppBriefRoute: AppBriefRouteWithChildren,
  AppCalendarRoute: AppCalendarRoute,
  AppCoordinateRoute: AppCoordinateRoute,
  AppGrowthRoute: AppGrowthRoute,
  AppHelpRoute: AppHelpRoute,
  AppInboxRoute: AppInboxRoute,
  AppMediaRoute: AppMediaRoute,
  AppMessagesRoute: AppMessagesRoute,
  AppOperatorRoute: AppOperatorRouteWithChildren,
  AppPublishRoute: AppPublishRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSmsRoute: AppSmsRouteWithChildren,
  AppTeamRoute: AppTeamRoute,
  AppTresciRoute: AppTresciRouteWithChildren,
  AppWygladRoute: AppWygladRoute,
  AppIndexRoute: AppIndexRoute,
  AppStronyPageIdRoute: AppStronyPageIdRoute,
  AppStronyIndexRoute: AppStronyIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  OperatorLoginRoute: OperatorLoginRoute,
  AuthSetPasswordTokenRoute: AuthSetPasswordTokenRoute,
  TeamAcceptTokenRoute: TeamAcceptTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
